import React, { useEffect, useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function Reports() {
  const API = "https://app.saravanabhava.in/reports.php";

  const [summary, setSummary] = useState({});
  const [daily, setDaily] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [emails, setEmails] = useState([]);

  useEffect(() => {
    fetch(`${API}?action=summary`).then(res => res.json()).then(setSummary);
    fetch(`${API}?action=daily`).then(res => res.json()).then(data => setDaily(data.daily || []));
    fetch(`${API}?action=campaigns`).then(res => res.json()).then(data => setCampaigns(data.campaigns || []));
    fetch(`${API}?action=emails`).then(res => res.json()).then(data => setEmails(data.emails || []));
  }, []);

  return (
    <div className="p-6 grid gap-6">
      {/* ✅ Summary */}
      <div className="grid grid-cols-3 gap-4">
        <Card className="p-4 text-center">
          <h2 className="text-xl font-bold">Sent</h2>
          <p className="text-2xl text-green-600">{summary.total_sent}</p>
        </Card>
        <Card className="p-4 text-center">
          <h2 className="text-xl font-bold">Pending</h2>
          <p className="text-2xl text-yellow-600">{summary.total_pending}</p>
        </Card>
        <Card className="p-4 text-center">
          <h2 className="text-xl font-bold">Failed</h2>
          <p className="text-2xl text-red-600">{summary.total_failed}</p>
        </Card>
      </div>

      {/* ✅ Daily Graph */}
      <Card>
        <CardContent>
          <h2 className="text-lg font-semibold mb-4">Daily Sent Emails</h2>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={daily.reverse()}>
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#4CAF50" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* ✅ Campaign Table */}
      <Card>
        <CardContent>
          <h2 className="text-lg font-semibold mb-4">Campaign Reports</h2>
          <table className="w-full border">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">ID</th>
                <th className="p-2 border">Subject</th>
                <th className="p-2 border">Status</th>
                <th className="p-2 border">Sent</th>
                <th className="p-2 border">Pending</th>
                <th className="p-2 border">Failed</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map(c => (
                <tr key={c.id} className="text-center">
                  <td className="p-2 border">{c.id}</td>
                  <td className="p-2 border">{c.subject}</td>
                  <td className="p-2 border">{c.status}</td>
                  <td className="p-2 border text-green-600">{c.sent}</td>
                  <td className="p-2 border text-yellow-600">{c.pending}</td>
                  <td className="p-2 border text-red-600">{c.failed}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>

      {/* ✅ Email Level Report */}
      <Card>
        <CardContent>
          <h2 className="text-lg font-semibold mb-4">Email Reports</h2>
          <table className="w-full border">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Queue ID</th>
                <th className="p-2 border">Email</th>
                <th className="p-2 border">Name</th>
                <th className="p-2 border">Subject</th>
                <th className="p-2 border">Status</th>
                <th className="p-2 border">Created</th>
                <th className="p-2 border">Sent At</th>
              </tr>
            </thead>
            <tbody>
              {emails.map(e => (
                <tr key={e.id} className="text-center">
                  <td className="p-2 border">{e.id}</td>
                  <td className="p-2 border">{e.email}</td>
                  <td className="p-2 border">{e.name}</td>
                  <td className="p-2 border">{e.subject}</td>
                  <td className={`p-2 border ${
                    e.status === "sent"
                      ? "text-green-600"
                      : e.status === "failed"
                      ? "text-red-600"
                      : "text-yellow-600"
                  }`}>
                    {e.status}
                  </td>
                  <td className="p-2 border">{e.created_at}</td>
                  <td className="p-2 border">{e.sent_at || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
